/**
 * `users.match_preferences` is a JSON column. Real MySQL hands it back parsed,
 * but MariaDB (the local dev database) stores JSON as LONGTEXT and returns the
 * raw string. Spreading that string (`{ ...user.match_preferences }`) turns it
 * into a char-indexed object ({"0":"{","1":"\"",…}) which the Discover page
 * then POSTs and the backend saves back — every load doubles the blob until
 * body-parser rejects it. Normalise once, at the point the user enters state.
 */
const isDigitKey = (k) => /^\d+$/.test(k);

export const normalizeMatchPreferences = (value, depth = 0) => {
  if (depth > 8) return {};
  if (typeof value === 'string') {
    try {
      return normalizeMatchPreferences(JSON.parse(value), depth + 1);
    } catch (e) {
      return {};
    }
  }
  if (!value || typeof value !== 'object') return {};
  if (!('0' in value)) return value;
  const inner = Object.keys(value)
    .filter(isDigitKey)
    .sort((a, b) => Number(a) - Number(b))
    .map((k) => value[k])
    .join('');
  const rest = Object.fromEntries(Object.entries(value).filter(([k]) => !isDigitKey(k)));
  return { ...rest, ...normalizeMatchPreferences(inner, depth + 1) };
};

export const normalizeUser = (user) => {
  if (!user || typeof user !== 'object' || !('match_preferences' in user)) return user;
  return { ...user, match_preferences: normalizeMatchPreferences(user.match_preferences) };
};
